export default "__VITE_ASSET__ClDjHDSG__"